import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SettingsMobilePage } from '@/pages/settings/settings-mobile-page';
import { SettingsPage } from '@/pages/settings/settings-page';
import { SETTINGS_TAB_IDS } from '@/pages/settings/settings-tabs';
import { useMobile } from '@/shared/lib/use-mobile';

// `/settings?team=acme` is the canonical entry — opened from a team's home
// page Settings button.  The bare `/settings` URL falls back to the first
// editable team so deep links from older messages still work.
//
// `tab` deep-links to a settings section.  The old standalone admin routes
// redirect here (§6 W5-D): `/workflows` + `/policies` (earlier), and now
// `/integrations`, `/knowledge`, `/trust-center`, `/teams/:slug/webhooks`.
// `workflow` pre-selects a workflow inside the Workflow tab's master-detail
// (used by Project Settings → "Edit graph").
//
// On a phone `?team=` opens that team's settings menu and `?tab=` one of its
// screens (status list, members, read-only roles / policies, …); without a
// team the phone page is the account menu.
const settingsSearch = z.object({
  team: z.string().optional(),
  // An unknown tab (an old link) falls back to the first tab instead of
  // failing the route.
  tab: z.enum(SETTINGS_TAB_IDS).optional().catch(undefined),
  workflow: z.string().optional(),
});

function SettingsRoute() {
  const isMobile = useMobile();
  return isMobile ? <SettingsMobilePage /> : <SettingsPage />;
}

export const Route = createFileRoute('/settings')({
  validateSearch: settingsSearch,
  component: SettingsRoute,
});
